<template>
  <div class="my-section">
    <div class="yellow-stripe left-stripe"></div>

    <div class="yellow-stripe right-stripe"></div>
    <div class="container">
      <div class="header">
        <h3 class="title text-primary">{{ $t('home.directions_section.title') }}</h3>
        <h4 class="subtitle text-grey-7">
          {{ $t('home.directions_section.subtitle') }}
        </h4>
      </div>

      <div class="row q-col-gutter-md justify-center">
        <div class="col-12 col-sm-auto col-md-4">
          <q-card class="section-card">
            <q-card-section>
              <div class="row items-center no-wrap">
                <q-icon name="person" size="3.5em" class="icon-bg" />
                <div class="step-number q-ml-auto">01</div>
              </div>

              <div class="text-h6 text-weight-bold text-primary q-mt-md">
                {{ $t('home.directions_section.col1_header') }}
              </div>
              <div class="text-body2 text-grey-7 q-mt-sm">
                {{ $t('home.directions_section.col1_par') }}
              </div>
            </q-card-section>
          </q-card>
        </div>

        <div class="col-12 col-sm-auto col-md-4">
          <q-card class="section-card">
            <q-card-section>
              <div class="row items-center no-wrap">
                <q-icon name="search" size="3.5em" class="icon-bg" />
                <div class="step-number q-ml-auto">02</div>
              </div>

              <div class="text-h6 text-weight-bold q-mt-md">
                {{ $t('home.directions_section.col2_header') }}
              </div>
              <div class="text-body2 text-grey-7 q-mt-sm">
                {{ $t('home.directions_section.col2_par') }}
              </div>
            </q-card-section>
          </q-card>
        </div>

        <div class="col-12 col-sm-auto col-md-4">
          <q-card class="section-card">
            <q-card-section>
              <div class="row items-center no-wrap">
                <q-icon name="check" size="3.5em" class="icon-bg" />
                <div class="step-number q-ml-auto">03</div>
              </div>

              <div class="text-h6 text-weight-bold q-mt-md">
                {{ $t('home.directions_section.col3_header') }}
              </div>
              <div class="text-body2 text-grey-7 q-mt-sm">
                {{ $t('home.directions_section.col3_par') }}
              </div>
            </q-card-section>
          </q-card>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.my-section {
  position: relative;
  overflow: hidden;
  background-color: #e6e7ed;
  padding: 280px 16px;
  padding-top: 120px;

  .header {
    padding-top: 80px;
    padding-bottom: 50px;
    text-align: center;

    .title {
      font-size: 40px;
      font-weight: bold;
    }

    .subtitle {
      font-size: 18px;
    }
  }

  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    height: 10px;
    transform: translateY(-50%);
    background-color: $primary;
  }
}

.section-card {
  box-shadow:
    0 10px 20px rgba(0, 0, 0, 0.19),
    0 6px 6px rgba(0, 0, 0, 0.23);
  border-radius: 20px;
  padding: 10px 20px;
  height: 300px;

  @media (max-width: 420px) {
    height: 350px;
  }
  @media (max-width: 350px) {
    height: 400px;
  }
}

.icon-bg {
  border-radius: 30px;
  background-color: $secondary;
  color: white;
  padding: 5px;
}

.step-number {
  color: white;
  -webkit-text-stroke: 2px $accent;
  font-size: 50px;
  font-weight: bolder;
  text-align: end;
}
</style>
<script setup lang="ts">
</script>
